import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

import defaultTranslations from "./DefaultTranslations.tsx";

(window as any).MISSING_TL_KEYS = {};
(window as any).GetMissingKeysEnum = () => {
  const s = Object.keys((window as any).MISSING_TL_KEYS).join(",\n");
  console.log("," + s);
  return s;
};

export const initTranslator = (baseUrl: string) => {
  i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init({
      lng: "fr",
      fallbackLng: "fr",
      react: {
        useSuspense: true
      },
      backend: {
        loadPath: `${baseUrl}/api/translation/?languageCode={{lng}}`,
        addPath: `${baseUrl}/api/translation/{{lng}}`,
        parse: (data: string) => {
          const parsed = JSON.parse(data);
          const reduced: object = parsed.reduce((prev, curr) => {
            prev[curr.translationCode] = curr.text;
            return prev;
          }, {});
          return reduced;
        },
        parsePayload: function(namespace, key, fallbackValue) {
          const defaultTrad = defaultTranslations[key];
          return {
            text: defaultTrad || fallbackValue,
            translationCode:  key
          };
        }
      },
      keySeparator: false,
      interpolation: {
        escapeValue: false
      },
      parseMissingKeyHandler: (key) => {
        const defaultTrad = defaultTranslations[key];
        return defaultTrad || `${key}_MISSING_TL`;
      },
      saveMissing: true
    });
};

